export default __webpack_public_path__ + "static/media/blue_needle.26442d73.svg";